import React, { Component } from 'react';
import { connect } from 'react-redux';

import AnnotationViews from './views';


class Annotation extends Component {
  render() {
    return <AnnotationViews { ...this.props } />;
  }
}

function mapStateToProp(state) {
  const { isMain } = state.annotation;

  return {
    isMain
  };
}


export default connect(mapStateToProp)(Annotation);
